"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A Component implementing a bootstrap card with internal tabs in the header
 */
var TabCard = function TabCard(_ref) {
  var selectedIndex = _ref.selectedIndex,
      onSelect = _ref.onSelect,
      tabs = _ref.tabs;
  var initialSelectedIndex = selectedIndex > 0 ? selectedIndex : 0;

  var _useState = (0, _react.useState)(initialSelectedIndex),
      _useState2 = _slicedToArray(_useState, 2),
      localSelectedIndex = _useState2[0],
      setLocalSelectedIndex = _useState2[1];

  var onTabSelect = function onTabSelect(e, selectedKey) {
    e.preventDefault();
    setLocalSelectedIndex(selectedKey);

    if (onSelect) {
      onSelect(e, selectedKey);
    }
  };

  var getTabClass = function getTabClass(index) {
    return index === localSelectedIndex ? 'nav-item active' : 'nav-item';
  };

  (0, _react.useEffect)(function () {
    if (selectedIndex >= 0) {
      setLocalSelectedIndex(selectedIndex);
    }
  }, [setLocalSelectedIndex, selectedIndex]);

  var renderTab = function renderTab(tabInfo, tabIndex) {
    return _react["default"].createElement("li", {
      key: tabIndex,
      className: getTabClass(tabIndex)
    }, _react["default"].createElement("a", {
      href: tabInfo.href || null,
      className: "nav-link",
      onClick: function onClick(e) {
        return onTabSelect(e, tabIndex);
      }
    }, _react["default"].createElement("strong", null, " ", tabInfo.name, " ")));
  };

  var renderTabNav = function renderTabNav() {
    return _react["default"].createElement("ul", {
      className: "nav card-tab-nav"
    }, " ", tabs.map(renderTab), " ");
  };

  var renderFooter = function renderFooter() {
    if (tabs[localSelectedIndex].footer) {
      return _react["default"].createElement("div", {
        className: "card-footer"
      }, " ", tabs[localSelectedIndex].footer, " ");
    }

    return null;
  };

  return _react["default"].createElement("div", {
    className: "card tab-card"
  }, _react["default"].createElement("div", {
    className: "card-header card-tabs"
  }, renderTabNav()), _react["default"].createElement("div", {
    className: "card-block"
  }, tabs[localSelectedIndex].block), renderFooter());
};

TabCard.propTypes = {
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].node.isRequired,
    block: _propTypes["default"].node.isRequired,
    footer: _propTypes["default"].node,
    href: _propTypes["default"].string
  })),
  onSelect: _propTypes["default"].func,
  selectedIndex: _propTypes["default"].number
};
TabCard.defaultProps = {
  tabs: [],
  onSelect: function onSelect() {},
  selectedIndex: undefined
};
var _default = TabCard;
exports["default"] = _default;